import { HeadCell } from 'components/pages/ClaimsManagement';

export const editFormLabels = {
    additionalInformation: 'Decision - Additional Information',
    amount: 'Amount',
    amountPayable: 'Amount Payable',
    benefitAmountPayableSumTotal: 'Benefit Amount Payable Sum Total',
    benefitDecisionDate: 'Date of Benefit Decision',
    borrowerName: 'Name',
    borrowerNameFirst: 'First Name',
    borrowerNameLast: 'Last Name',
    claimDecision: 'Claim Decision',
    claimDecisionDate: 'Claim Decision Date',
    claimIdentifier: 'Identifier Key',
    claimNumber: 'Claim Number',
    claimSpecialistName: 'Name of Claim Specialist',
    claimStateUpdatedDate: 'Claim Status Updated',
    claimStatus: 'Claim Status',
    claimSubmitDate: 'Claim Submit Date',
    dateFiled: 'Date Filed',
    dateDecisionSent: 'Date decision email sent to Borrower',
    decisionReason: 'Denial Reason',
    disablingCondition: 'Disabling Condition',
    distributorName: 'Distributor',
    eConsentReceived: 'E-Consent received from Borrower',
    emailAddress: 'Email Address',
    fastTracked: 'Was claim Fast Tracked?',
    incurredDate: 'Incurred Date',
    last4SSN: 'Last 4 SSN',
    loanNumber: 'Loan Number',
    policyNumber: 'Policy Number',
    loanServicerName: 'Loan Servicer',
    lossType: 'Loss Type',
    notes: 'Notes',
    reasonForJobLoss: 'Reason for Job Loss',
    status: 'Status'
};
export const claimBenefitFormLabels = {
    amountPayable: 'Benefit Amount Payable',
    benefitDecision: 'Benefit Decision',
    benefitId: 'Benefit Id',
    claimDecisionDate: 'Date of Benefit Decision',
    claimPolicyRelationshipId: 'Claim Policy Relationship Id',
    dateCertificateEffective: 'Certificate Effective Date',
    dateDecisionSent: 'Date decision email sent to Borrower',
    decisionAdditionalInformation: 'Reason claim was not fast tracked',
    decisionReason: 'Denial Reason',
    externalSystemIdentifier: 'External System Identifier'
};
export const SurveyCSVLabels = {
    adjuster: 'Adjuster',
    adjusterFirstName: 'AdjusterFirstName',
    age: 'Age',
    age_Cats: 'Age_Cats',
    annuityAdjuster: 'AnnuityAdjuster',
    benePhone: 'BenePhone',
    beneRelationship: 'BeneRelationship',
    beneficiarySettlementType: 'BeneficiarySettlementType',
    birth_Date: 'Birth_Date',
    cellPhone1: 'CellPhone1',
    cellPhoneNumber2: 'CellPhoneNumber2',
    children_In_Household_Count: 'Children_In_Household_Count',
    claimDurationInMonths: 'ClaimDurationInMonths',
    claimEnteredDate: 'ClaimEnteredDate',
    claimNumber: 'ClaimNumber',
    claimPaymentAmount: 'ClaimPaymentAmount',
    claimPaymentDate: 'ClaimPaymentDate',
    claimStatus: 'ClaimStatus',
    claimType: 'ClaimType',
    closeDate: 'CloseDate',
    closeReason: 'CloseReason',
    college_Graduate_Flag: 'College_Graduate_Flag',
    complexityRating: 'ComplexityRating',
    contestable: 'Contestable',
    contractNumber: 'ContractNumber',
    cP_Type: 'CP_Type',
    cover_Type: 'Cover_Type',
    coverageName: 'CoverageName',
    coveragePaymentAmt: 'CoveragePaymentAmt',
    creditUnion: 'CreditUnion',
    cust_ID: 'Cust.ID',
    dateofDeath: 'DateofDeath',
    deskCode: 'DeskCode',
    dPProductRelease: 'DPProductRelease',
    education_Of_1st_Individual_Code: 'Education_Of_1st_Individual_Code',
    email: 'Email',
    estimated_Income_Code: 'Estimated_Income_Code',
    fileName: 'FileName',
    fillingMethod: 'FillingMethod',
    fNOLClaim: 'FNOLClaim',
    gender: 'Gender',
    home_Owner_Or_Renter_Indicator: 'Home_Owner_Or_Renter_Indicator',
    informant_FirstName: 'Informant_FirstName',
    informant_LastName: 'Informant_LastName',
    informantRelationship: 'InformantRelationship',
    input_Individuals_Birth_Date: 'Input_Individuals_Birth_Date',
    insuredName: 'InsuredName',
    lastSampleMonth: 'LastSampleMonth',
    marital_Newlywed_Flag: 'Marital_Newlywed_Flag',
    marital_Status_Code: 'Marital_Status_Code',
    member_FirstName: 'Member_FirstName',
    member_LastName: 'Member_LastName',
    memberNumber: 'MemberNumber',
    military_Veteran_Flag: 'Military_Veteran_Flag',
    name: 'Name',
    net_Worth_Code: 'Net_Worth_Code',
    nFCU: 'NFCU',
    noticeReceivedDate: 'NoticeReceivedDate',
    noticeReportDate: 'NoticeReportDate',
    notificationType: 'NotificationType',
    num_OfClaimsSubmittedPrev_Yr: 'Num.OfClaimsSubmittedPrev.Yr',
    orig_Product: 'Orig_Product',
    ownerSite: 'OwnerSite',
    payeeName: 'PayeeName',
    paymentDate: 'PaymentDate',
    paymentType: 'PaymentType',
    personOrOrganization: 'PersonOrOrganization',
    phoneNumber: 'PhoneNumber',
    policy_Number: 'Policy_Number',
    policyNumber: 'PolicyNumber',
    presence_Of_Senior_Adult_Flag: 'Presence_Of_Senior_Adult_Flag',
    product: 'Product',
    race_Code: 'Race_Code',
    short_claimnumber: 'short_claimnumber',
    site: 'Site',
    state: 'State',
    stocks_Bonds_Flag: 'Stocks_Bonds_Flag',
    surplus_Lines: 'Surplus_Lines',
    teamLead: 'TeamLead',
    teamType: 'TeamType',
    thresholdLevel: 'ThresholdLevel',
    address: 'Address'
};

export const headCells: readonly HeadCell[] = [
    {
        id: 'nameFirst',
        numeric: false,
        disablePadding: true,
        label: editFormLabels.borrowerNameFirst
    },
    {
        id: 'nameLast',
        numeric: false,
        disablePadding: false,
        label: editFormLabels.borrowerNameLast
    },
    {
        id: 'distributorName',
        numeric: false,
        disablePadding: false,
        label: editFormLabels.distributorName
    },
    {
        id: 'claimNumber',
        numeric: false,
        disablePadding: false,
        label: editFormLabels.claimNumber
    },
    {
        id: 'borrowerIdentifierKey',
        numeric: false,
        disablePadding: false,
        label: editFormLabels.claimIdentifier
    },
    {
        id: 'claimCreateDate',
        numeric: false,
        disablePadding: false,
        label: editFormLabels.dateFiled
    },
    {
        id: 'peril',
        numeric: false,
        disablePadding: false,
        label: editFormLabels.lossType
    }
];
